import { ISchedulingProfile } from './scheduling-profile.interface';

export class SchedulingProfile {
  createdAt: string;
  directScheduleEnabled: string;
  id: number;
  maxAdvance: number;
  minAdvance: number;
  personaProviderId: number;
  updatedAt: string;
  directSchedulingSessionDuration: number;
  directSchedulingStartInterval: number;
  directSchedulingBuffer: number;
  minimumAdvanceHoursForTimeProposal: number;
  maximumAdvanceWeeksForTimeProposal: number;
  workingHoursTimezone: string;

  constructor(json: ISchedulingProfile) {
    this.createdAt = json.created_at;
    this.directScheduleEnabled = json.direct_scheduling_enabled;
    this.id = json.id;
    this.personaProviderId = json.persona_provider_id;
    this.updatedAt = json.updated_at;
    this.maxAdvance = json.maximum_advance_weeks;
    this.minAdvance = json.minimum_advance_hours;
    this.directSchedulingSessionDuration = json.direct_scheduling_session_duration;
    this.directSchedulingStartInterval = json.direct_scheduling_start_interval;
    this.directSchedulingBuffer = json.direct_scheduling_buffer;
    this.minimumAdvanceHoursForTimeProposal = json.minimum_advance_hours_for_time_proposal;
    this.maximumAdvanceWeeksForTimeProposal = json.maximum_advance_weeks_for_time_proposal;
    this.workingHoursTimezone = json.working_hours_tz;
  }
}
